<script lang="ts">
    
    import { fly, fade } from 'svelte/transition';
    import LottiePlayer from "../Components/LottiePlayer.svelte";
    import Loading from '../Components/Loading.svelte';
    import type { Fn } from '../global';
    import { getContext } from 'svelte';
    import { navigate } from 'svelte-navigator';

    const playMainTheme: Fn = getContext('playMainTheme');

    function onStart(): void {
        playMainTheme();
        navigate('avatar');
    }

</script>

<style lang="scss">

    $logo-height: 12vh;

    .view {
        height: calc(100% - #{$logo-height});
        z-index: 99999;
    }

    .animation {
        position: relative;
        padding-top: 2rem;
        flex: 1 1 0;
        min-height: 0;
        align-content: center;
        margin: auto;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .animation img {
        width: 100%;
        max-width: 250px;
        height: 100%;
        object-fit: contain;
        margin: auto;
        animation: float 3s ease-in-out infinite;
    }

    .link {
        margin: 1rem 0;
        text-align: center;

    }

    .start-btn {
        border: none;
        color: #fff;
        font-size: 1.1rem;
        background-color: transparent;
    }

    .logo {
        height: 100%;
        max-height: $logo-height;
        width: 100%;
        box-sizing: border-box;
        // padding-top: 20px;
        text-align: center;
        position: relative;
        overflow: hidden;
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;

        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 150%;
            height: 160%;
            border-radius: 50%;
            background-color: #fff;

            @media screen and (min-width: 450px) {
                // height: 250%;
                // top: 5vh;
            }

            @media screen and (min-width: 650px) {
                // top: 1vh;
            }
        }

        img {
            height: 6vh;
            max-height: 80px;
            width: auto;
            // position: absolute;
            // bottom: 2vh;
            z-index: 2;

            // &::before {
            //     @media screen and (max-width: 450px) {
            //         bottom: 4vh;
            //     }
            // }
        }
    }

    .header {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .tag {
        margin-top: 1rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        padding-left: 1rem;
        padding-right: 1rem;
        text-align: center;
        background-color: #0000007c;
        border: 1px solid white;
        border-radius: 5rem;
        font-size: 2vw;
        font-weight: 100;
        color: white;
        font-family: arial;
        width: fit-content;

        @media screen and (max-width: 900px) {
            font-size: 3.5vw !important;
        }
    }

    .title {
        text-align: center;
        margin: 2rem;

        font-size: calc(2.5vw + 2.5vh);
        margin-bottom: 1rem;
        color: white;
        text-shadow: 2px 2px 4px black;

        line-height: calc(2vh + 2vw);

        @media screen and (max-width: 900px) {
            font-size: calc(3vw + 3vh);
            line-height: calc(2.5vh + 2.5vw);
        }
    }

    @keyframes float {
        0% {
            transform: translateY(0);
        }

        50% {
            transform: translateY(-20px);
        }

        100% {
            transform: translateY(0);
        }
    }

    .bg-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: -1;
    }

    .view-wrapper {
        background-color: #96745E !important;
    }

</style>

<div class="view" on:click={onStart}>
    <img src="images/fondo-trivial-genio.svg" alt="Ayuntamiento de Telde" class='bg-img'>
    <div class='header'>
        <span class='tag'>UN TRIVIAL REALEJERO</span>
        <span class='title'>
            ¿Cuánto sabes de la Fusión Municipal?
        </span>
    </div>
    <div class="animation" in:fade>
        <!-- <LottiePlayer src="animations/todo_el_grupo.json" /> -->
        <img src="images/genio.png" alt="Ayuntamiento de Telde" >

    </div>

    <div class="link" in:fade={{ delay: 500 }}>
        <button type="button" class="start-btn" on:click={onStart}>PULSA PARA EMPEZAR</button>
    </div>
</div>

<div class="logo" in:fly={{ y: 200 }}>
    <img in:fly={{ y: 100, delay: 50 }} src="images/los_realejos_logo.png" alt="Ayuntamiento de Telde">
</div>

